import { compareDesc as dateFnsCompareDesc } from 'date-fns';

const compareDesc = (firstDate, secondDate) => (dateFnsCompareDesc(new Date(firstDate), new Date(secondDate)));

export default compareDesc;
